import React from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function BycycleSlider() {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1064,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };
  return (
    <div>
    <section className="section-padding car-booking">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-heading">
            <h3 className="text-custom-black">Recommended <span className="text-custom-blue">Bicycle</span></h3>
            <div className="section-description">
              <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Slider {...settings} className="bicycle-slider arrow-layout-2 row">
              <div className="slide-item col-12">
                <div className="bicycle-grid">
                  <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                    <div className="image-sec animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                    <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                      <h4 className="title fs-16"><Link to="/blog-details" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per day</small></Link></h4>
                      <span className="price"><small>From</small>$20</span>
                      <div className="action"> <Link className="btn-second btn-small" to="/bicycle-detail">View</Link> <Link className="btn-first btn-submit yellow" href="booking.html">Book</Link> </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="slide-item col-12">
                <div className="bicycle-grid">
                  <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                    <div className="image-sec animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-3.jpg" className="full-width" alt="img"/> </Link> </div>
                    <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                      <h4 className="title fs-16"><Link to="/blog-details" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per day</small></Link></h4>
                      <span className="price"><small>From</small>$35</span>
                      <div className="action"> <Link className="btn-second btn-small" to="/bicycle-detail">View</Link> <Link className="btn-first btn-submit yellow" href="booking.html">Book</Link> </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="slide-item col-12">
                <div className="bicycle-grid">
                  <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                    <div className="image-sec animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                    <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                      <h4 className="title fs-16"><Link to="/blog-details" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per day</small></Link></h4>
                      <span className="price"><small>From</small>$50</span>
                      <div className="action"> <Link className="btn-second btn-small" to="/bicycle-detail">View</Link> <Link className="btn-first btn-submit yellow" href="booking.html">Book</Link> </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="slide-item col-12">
                <div className="bicycle-grid">
                  <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                    <div className="image-sec animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-3.jpg" className="full-width" alt="img"/> </Link> </div>
                    <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                      <h4 className="title fs-16"><Link to="/blog-details" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per day</small></Link></h4>
                      <span className="price"><small>From</small>$68</span>
                      <div className="action"> <Link className="btn-second btn-small" to="/bicycle-detail">View</Link> <Link className="btn-first btn-submit yellow" href="booking.html">Book</Link> </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="slide-item col-12">
                <div className="bicycle-grid">
                  <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                    <div className="image-sec animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                    <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                      <h4 className="title fs-16"><Link to="/blog-details" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per day</small></Link></h4>
                      <span className="price"><small>From</small>$58</span>
                      <div className="action"> <Link className="btn-second btn-small" to="/bicycle-detail">View</Link> <Link className="btn-first btn-submit yellow" href="booking.html">Book</Link> </div>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default BycycleSlider